export type MarketCoordinator = {
  user_id: string;
  user_name: string;
  profile_url: string;
};

export type AssignedZipEntry = {
  market_id: string;
  market_name: string;
  zip_codes: string[];
};

// Raw property shape as returned by the API — lat/lng arrive as strings. Coerced into
// MarketMapProperty (number lat/lng) at the map boundary (see MarketDetail index useMemo).
export type ApiMarketProperty = {
  property_id: string;
  address: string;
  zip_code: string;
  latitude: string;
  longitude: string;
};

export type MarketDetailResponse = {
  market_id: string;
  market_name: string;
  zip_codes: string[];
  blocked_zipcodes: AssignedZipEntry[];
  properties: ApiMarketProperty[];
  coordinators: string[];
};

export type BlockedZipInfo = {
  market_id: string;
  market_name: string;
};

export type MarketMapProperty = {
  property_id: string;
  address: string;
  zip_code: string;
  latitude: number;
  longitude: number;
};

export type Market = {
  market_id: string;
  market_name: string;
  zip_code_count?: number;
  zip_codes?: string[];
  properties_count: number;
  coordinators: MarketCoordinator[];
  coordinator_ids?: string[];
  market_properties?: ApiMarketProperty[];
};

export type MarketsMeta = {
  current_page: number;
  from: number;
  last: string;
  next: string;
  per_page: number;
  prev: string;
  to: number;
  total: number;
};

export type CreateMarketPayload = {
  name: string;
  zip_codes: string[];
  coordinators: string[];
};

export type CoordinatorOption = {
  value: string;
  label: string;
  email?: string;
  profile_pic?: string | null;
  assigned_market_count?: number;
};

export type MarketDeleteValidation = {
  properties_count: number;
  open_service_requests_count: number;
};

export type MarketFormValues = {
  name: string;
  coordinators: CoordinatorOption[];
};

export type MarketsState = {
  isLoading: boolean;
  data: {
    data: string[];
    meta: MarketsMeta;
  };
  source: Record<string, Market>;
  activeMarketId: string | null;
  unassignedPropertiesCount: number;
  assignedZips: Record<string, BlockedZipInfo>;
  isAssignedZipsLoading: boolean;
  marketDetailLoading: boolean;
  isMarketDeleting: boolean;
};

export const marketsInitialState: MarketsState = {
  isLoading: false,
  data: {
    data: [],
    meta: { current_page: 0, from: 0, last: '', next: '', per_page: 25, prev: '', to: 0, total: 0 },
  },
  source: {},
  activeMarketId: null,
  unassignedPropertiesCount: 0,
  assignedZips: {},
  isAssignedZipsLoading: false,
  marketDetailLoading: false,
  isMarketDeleting: false,
};
